import React, { FC, useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { MinistriesContainer } from '../../components/ministries/MinistriesContainer';

const MinistriesPage: FC = () => {
  const navigate = useNavigate();
  const { me } = useAuth();

  useEffect(() => {
    if (!me) return;
    if (!me?.isSuperuser && !me?.role?.viewCMS) navigate('/');
  }, [me, me?.isSuperuser, me?.role?.viewCMS, navigate])

  return (
    <Box>
      <MinistriesContainer />
    </Box>
  );
};

export default MinistriesPage;
